import { Component, ViewChild } from "@angular/core";
import { environment } from "../environments/environment";

import { routerTransition } from "./shared/animations/index";
import { Router, NavigationEnd } from "@angular/router";
import { ControllerService } from "./shared/services/controller.service";
import { StoreHelper } from "./shared/helpers/store.helper";
import { AuthService } from "./auth/auth.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  host: { "[@routerTransition]": "" },
  animations: [routerTransition],
  standalone: false
})
export class AppComponent {
  @ViewChild("innerWrapper", { static: true }) innerWrapper;

  title = environment.name;

  constructor(
    private router: Router,
    public controller: ControllerService,
    public authService: AuthService
  ) {
    if (environment.googleAnalyticsTag !== "") {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          (<any>window).gtag?.("event", "page_view", {
            page_title: event.urlAfterRedirects,
            page_location: event.urlAfterRedirects,
          });
        }
      });
    }
  }

  backToStart() {
    this.controller.setPreviewing(false)
    if (this.authService.isAuthenticatedHr()) {
      const clientName = StoreHelper.getCurrentUser().client_name
      this.controller.shiftContainerToTop()
      this.router.navigate([`client/${clientName}/report`])
    } else {
      this.router.navigate(['/content/all'])
    }
  }

  async ngOnInit() {
    // don't navigate to start for certain routes


    this.controller.setInnerWrapper(this.innerWrapper);

    var search = location.search.substring(1);

    let queryParams: any = {}


    try {
      queryParams = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
    } catch (e) {
    }

    if (window.location.pathname.startsWith('/client')) {

      // Fix for client names with Ampersands (e.g. A&OShearman)
      // Angular Router might fail to match unencoded '&' in path, falling back to wildcard -> start -> client list.
      if (window.location.pathname.indexOf('&') > -1) {
        const newPath = window.location.pathname.replace(/&/g, '%26');
        this.router.navigateByUrl(newPath + window.location.search);
        return;
      }

      return;
    }

    if (window.location.pathname.startsWith('/adhoc')) {
      return;
    }

    if (window.location.pathname.startsWith('/mass-section')) {
      return;
    }

    if (window.location.pathname === "/terms-of-use") {
      return;
    }

    if( window.location.pathname.startsWith('/template') ){
      return;
    }

    if (window.location.pathname === "/tags") {
      return;
    }

    if (window.location.pathname === "/manage-videos") {
      return;
    }



    if (window.location.pathname.startsWith("/content-editor")) {
      return;
    }

    if (window.location.pathname === "/reset-password") {
      return;
    }
    if (window.location.pathname == '/xapi') {
      return;
    }

    if (window.location.pathname == '/content/global-search-replace') {
      return;
    }

    if (window.location.pathname.startsWith('/content')) {
      return;
    }

    if (window.location.pathname.startsWith('/user')) {
      return;
    }

    if (window.location.pathname.startsWith('/code')) {
      return;
    }
    if (window.location.pathname == '/shared-reflections') {
      return;
    }

    if (window.location.pathname == "/sso") {
      // merge params
      if (queryParams.activationCode) {
        StoreHelper.setObject('activationCode', queryParams.activationCode)
      }
      return
    }


    if (window.location.pathname == '/start') {

      // merge params
      if (queryParams.activationCode) {
        StoreHelper.setObject('activationCode', queryParams.activationCode)
      }

      if (queryParams.contentLibraryId) {
        StoreHelper.setObject('contentLibraryId', queryParams.contentLibraryId)
      } else {
        StoreHelper.removeObject('contentLibraryId')
      }

      this.router.navigate(["/start"], {
        queryParams,
        queryParamsHandling: "merge"
      });

      return
    }

    this.router.navigate(["/start"]);
  }
}
